import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { TokenStorageService } from '../services/token-storage.service';

export function httpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthenticationService);
  const tokenStorageService = inject(TokenStorageService);

  if (req.url.includes(environment.apiHost)) {
    const token = tokenStorageService.getToken();
    let authReq = req;

    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !req.url.includes('authentication/google-auth-url')) {
          const currentToken = tokenStorageService.getToken();
          if (token && token === currentToken) {
            authService.clearAuthAndRedirect();
          }
        }
        return throwError(() => error);
      })
    );
  }

  return next(req);
}
